import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CheckKeys, CheckTransactionKeys } from '@config/keys/check.keys';
import {
  DoodOpenCheck,
  DoodOpenCheckItem,
  DoodOpenCheckTransaction,
} from '@core/models/check.model';

@Component({
  selector: 'app-check-overview-atom',
  templateUrl: './check-overview-atom.component.html',
  standalone: false,
})
export class CheckOverviewAtomComponent implements OnInit, OnChanges {
  @Input() check!: DoodOpenCheck;

  capturedTransactons!: DoodOpenCheckTransaction[];

  checkKeys = CheckKeys;

  private checkIdForExpandedDescriptions: string | undefined;

  /** Item ids whose check line description is shown expanded (full text). */
  private readonly expandedItemDescriptionIds = new Set<string>();

  constructor() {}

  ngOnInit(): void {
    if (this.checkKeys) {
      this.capturedTransactons = this.check?.[CheckKeys.Transactions].filter(
        transaction => transaction?.[CheckTransactionKeys.Status] === 'CAPTURED',
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['check'] && this.check?.id !== this.checkIdForExpandedDescriptions) {
      this.checkIdForExpandedDescriptions = this.check?.id;
      this.expandedItemDescriptionIds.clear();
    }
    if (this.checkKeys) {
      this.capturedTransactons = this.check?.[CheckKeys.Transactions].filter(
        transaction => transaction?.[CheckTransactionKeys.Status] === 'CAPTURED',
      );
    }
  }

  shouldShowItemDescription(item: DoodOpenCheckItem): boolean {
    const desc = item.description?.trim();
    return Boolean(desc && desc !== item.name?.trim());
  }

  isItemDescriptionExpanded(itemId: string): boolean {
    return this.expandedItemDescriptionIds.has(itemId);
  }

  onItemRowClick(item: DoodOpenCheckItem): void {
    if (!this.shouldShowItemDescription(item)) {
      return;
    }
    if (this.expandedItemDescriptionIds.has(item.id)) {
      this.expandedItemDescriptionIds.delete(item.id);
    } else {
      this.expandedItemDescriptionIds.add(item.id);
    }
  }
}
